<!-- <dx-menubar #menubar *ngIf="loggedOnUser" [menuItems]="appMenuItems" [adjacentItems]="rightMenuBarItems"></dx-menubar> -->
<dx-toolbar [controls]="tbControls"></dx-toolbar>
<div class="spinner-loader" *ngIf="authSvc.showLoader">
    <p-progressSpinner></p-progressSpinner>
    <div class="loader-text">Loading ...</div>
</div>
<div style="margin-left: 100px;margin-right: 100px;">
    <router-outlet></router-outlet>
</div>



